"use strict";
/**
 * Neccessary so that all new items being pushed into an array can be reflected and proxied
 * if neccesary (e.g. maps).
 */
Object.defineProperty(exports, "__esModule", { value: true });
var proxiedPush = function (arr, proxy, newItems) {
    while (newItems.length) {
        var newItem = newItems.shift();
        proxy[arr.length] = newItem;
    }
    return arr.length;
};
exports.default = proxiedPush;
//# sourceMappingURL=proxiedPush.js.map